import RecycleRIGHTGame from './RecycleRIGHTGame';

export default RecycleRIGHTGame;
